import _ from 'lodash';
import { useEffect } from 'react';

const functions = {};

/**
 * useFunction - helper hooks to pass function implementation between decoupled components.
 * For example, parent component can call any function of the child component without knowing its implementation.
 *
 * callbacks: array of strings with function names we want to subscribe to (external functions to call).
 * When function is called, it is being searched by name in invokers list if it has been registered
 * 
 * invokers: function implementations that are registered for other components to use.
 * 
 * @export
 * @param {*} {callbacks, invokers}
 * @return {*} 
 */
export default function useFunction({callbacks, invokers}) {
  _.forOwn(invokers, (value, key) => {
    if (!key || !value) {
      return;
    }

    functions[key] = value;
  });


  useEffect(() => {
    return () => cleanup();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function createCallbacks() {
    const filteredCallbacks = {};

    if (callbacks) {
      callbacks.forEach(c => {
        if (functions[c]) {
          filteredCallbacks[c] = functions[c];
        } else {
          filteredCallbacks[c] = () => {
            window.console.warn(`Function ${c} not defined`);
            window.console.log(functions);
          };
        }
      });
    }

    return filteredCallbacks;
  }


  function cleanup() {
    _.forOwn(invokers, (_, key) => {
      if (!key) {
        return;
      }
  
      delete functions[key];
    });
  }

  return createCallbacks;
}
  